import { useStore } from 'hooks/useStore';
import { useState } from 'react';
import { factScreenServices } from 'services/factsScreenServices';

const useMarketStrategyAddModal = ({
  handleNewStrategySelect,
}: {
  handleNewStrategySelect: (option: { code: string; name: string }) => void;
}) => {
  const [name, setName] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [isAddLoading, setIsAddLoading] = useState(false);
  const [errors, setErrors] = useState<string>('');

  const {
    FactsStore: { toggleMarketStrategyAddModalVisibility, fetchAllTargetMarketStrategyCodes },
  } = useStore();

  const addMethods = {
    handleAddTMSStrategy: async () => {
      try {
        if (!name && !description) {
          setErrors(() => 'Name and Description is required');
          return;
        }
        if (!name) {
          setErrors(() => 'Name is required');
          return;
        } else if (!description) {
          setErrors(() => 'Description is required');
          return;
        }
        // return;

        setIsAddLoading(true);
        setErrors('');
        await factScreenServices.addTMSStrategy({
          TMSStrategyCode: name,
          TMSDescription: description,
          BusinessOwner: 'SalesOps',
        });
        await fetchAllTargetMarketStrategyCodes();
        handleNewStrategySelect({ name: name, code: name });
        setName(() => '');
        setDescription(() => '');
        toggleMarketStrategyAddModalVisibility();
      } catch (_err) {
        setErrors(() => `TMS Strategy with name '${name}' already exists`);
      } finally {
        setIsAddLoading(false);
      }
    },
  };

  return {
    name,
    setName,
    description,
    setDescription,
    addMethods,
    isAddLoading,
    errors,
  };
};

export default useMarketStrategyAddModal;
